import { AutocompleteFilters } from "@aipb/gulliver/castor/model";
import { CastorMapper } from './mapper';

export class AutocompleteFiltersMapper implements CastorMapper<AutocompleteFilters> {
  map(o: AutocompleteFilters): { [p: string]: any } {
    if (!o) return {};

    const params = {};

    for (const k of Object.keys(o)) {
      if (!o[k]) continue;

      params[k] = o[k];
    }

    return params;
  }
}
